import { useSuspenseQuery } from '@tanstack/react-query';

import { accountLayoutQueryOptions } from '@lib/query/options/account';
import Overview from '@modules/account/components/overview';

/**
 * Account Overview Page
 *
 * Displays customer profile information with editable fields.
 * Uses account layout query to get customer data.
 */
export default function AccountOverviewPage() {
  const { data } = useSuspenseQuery(accountLayoutQueryOptions());

  if (!data.customer) {
    return null;
  }

  return <Overview customer={data.customer} />;
}
